class ajaxCart extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.bindOverlay();
    this.setHeaderCartIconAccessibility();
  }
  bindOverlay() {
    const overlay = this.querySelector('#ajaxcart-overlay');
    if (!overlay || overlay.dataset.cartCloseBound === 'true') return;
    overlay.addEventListener('click', this.close.bind(this));
    overlay.dataset.cartCloseBound = 'true';
  }
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#ajax-cart-icon');
    if (!cartLink || cartLink.dataset.cartOpenBound === 'true') return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
    cartLink.dataset.cartOpenBound = 'true';
  }
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});
    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.cart-inner-empty') : document.getElementById('ajaxcart');
      const focusElement = this.querySelector('.drawer-inner');
      triggerClick(containerToTrapFocusOn, focusElement);
    }, { once: true });
  }
  close() {
    this.classList.remove('active');
    triggerClickClose(this.activeElement);
  }
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');
    if(cartDrawerNote.nextElementSibling && cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }
    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
    if (cartDrawerNote.parentElement) cartDrawerNote.parentElement.addEventListener('keyup', escClick);
  }
  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer-inner');
    if (drawerInner) drawerInner.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.fetchSecToInclude().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      const sectionHTML = this.callSectionInnerHTML(parsedState.sections && parsedState.sections[section.id], section.selector, section.id);
      if (!sectionElement || sectionHTML === null) {
        console.warn('[Stardrix cart] Skipped missing Ajax section', {
          section: section.id,
          targetFound: Boolean(sectionElement),
          responseFound: Boolean(parsedState.sections && parsedState.sections[section.id])
        });
        return;
      }
      sectionElement.innerHTML = sectionHTML;
    }));
    setTimeout(() => {
      this.bindOverlay();
      this.setHeaderCartIconAccessibility();
      this.open();
    });
  }
  callSectionInnerHTML(html, selector = '.shopify-section', sectionId) {
    if (typeof html !== 'string') return null;
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const sectionNode = parsedHTML.querySelector(selector) || (sectionId ? parsedHTML.getElementById(sectionId) : null);
    return sectionNode ? sectionNode.innerHTML : null;
  }
  fetchSecToInclude() {
    return [
      {
        id: 'ajax-cart',
        selector: '#ajaxcart'
      },
      {
        id: 'ajax-cart-icon'
      }
    ];
  }
  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define('ajax-cart', ajaxCart);
class ajaxCartPro extends CartProduct {
  fetchSecToInclude() {
    return [
      {
        id: 'ajaxcart',
        section: 'ajax-cart',
        selector: '.drawer-inner'
      },
      {
        id: 'ajax-cart-icon',
        section: 'ajax-cart-icon',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-pro', ajaxCartPro);
